import { getAdditionalPrice, selectQuote, selectSelectedPriceAnnualCost } from 'Quotes/selectors';
import { ProductType } from 'Quotes/types/productTypes';
import React, { FunctionComponent } from 'react';
import CostDisplay from './CostDisplay';
import { IPriceData, IQuote } from '../../../../../types/store';
import { connect } from 'react-redux';
import { IAppState } from 'reducers';
import { TIER_NAMES } from '../DDOSProtection';

interface CostsInternalAnnualProps {
  selectedPriceAnnualCost: ReturnType<typeof selectSelectedPriceAnnualCost>;
  isFTTXQuote: boolean;
  portsCostAnnual: number;
  bandwidthCostAnnual: number;
  productType: ProductType | null | undefined;
  geaCableLinkAnnual: number;
  isManagedDIA: boolean;
  mdiaServiceCost: number;
  quote: IQuote;
  selectedPrice: IPriceData;
}

export const CostsInternalAnnual: FunctionComponent<React.PropsWithChildren<CostsInternalAnnualProps>> = ({
  selectedPriceAnnualCost,
  productType,
  portsCostAnnual,
  bandwidthCostAnnual,
  geaCableLinkAnnual,
  isManagedDIA,
  isFTTXQuote,
  mdiaServiceCost,
  quote, 
  selectedPrice
}) => {

  return (
    <>
      <CostDisplay label="A-End Supplier Costs" cost={selectedPriceAnnualCost.A} />

      <CostDisplay label={(productType === ProductType.DIA || productType === ProductType.P2CCT || productType === ProductType.NNI2CCT) ? "Cloud Connect Supplier Costs" : "B-End Supplier Costs"} cost={selectedPriceAnnualCost.B} />

      {portsCostAnnual > 0 && <CostDisplay label="Port Costs" cost={portsCostAnnual} />}

      {productType === ProductType.OpticalP2P && <CostDisplay label="Cross Connect Costs" cost={bandwidthCostAnnual} />}

      {productType === ProductType.DIA && <CostDisplay label="Bandwidth Costs" cost={bandwidthCostAnnual} />}

      {isFTTXQuote && geaCableLinkAnnual > 0 && <CostDisplay label="GEA Cablelink Costs" cost={geaCableLinkAnnual} />}

      {productType === ProductType.DIA && isManagedDIA && mdiaServiceCost > 0 && (
        <CostDisplay label="Managed DIA services Costs" cost={mdiaServiceCost} />
      )}
      
      {quote?.ddosProtection && ( 
        <CostDisplay label={`DDoS Protection (${TIER_NAMES[quote?.ddosProtection]})`} 
          cost={getAdditionalPrice(selectedPrice.additional_prices, `DDoS Protection - ${quote.ddosProtection} Cost`)?.annual ?? 0} />
      )}
    </>
  );
};

const mapStateToProps = (state: IAppState) => ({
  quote: selectQuote(state),
});

export default connect(mapStateToProps)(CostsInternalAnnual);
